<template>
    <div class="mb-5" id="plan" v-if="isMobile()">
        <div class="">
        <h1 class="titulo_planes p-5"> Haz click con tu capital humano</h1>
        <div class="row ">
            <div class="col-lg-6 col-sm-12">
            <div class="col-lg-6 col-sm-12 ">
                <h1 class="plan_titulo"> BASIC </h1>
                <h2 class="plan_subtitulo">Sistema básico</h2>
                <br />
                <img class="img_opciones mb-4" src="static/images/planes.png" alt="plan_basico" />
                <br />

                <ul  class="lista_plan">
                    <li v-for="plan in planes" :key="plan.id" :class="plan.tipo == 'prime' ? 'no_aplica':''" >{{plan.nombre}}</li>
                </ul>
                
            </div>
            <div class="prime_content" style="text-align: center; padding-top:30%; padding-bottom:10%">
                <b-button @click="linkContact()" pill class="btn btn_plan">Solicitar demo</b-button>
                <br />
                <b-collapse id="plan_detail">

                <ul  class="lista_plan_completo">
                    <li v-for="plan in planes" :key="plan.id" :class="plan.tipo == 'prime' ? 'no_aplica_completo':''" >
                        {{plan.nombre}}
                        <ul>
                            <li v-for="subtitulo in plan.subtitulos" :key="subtitulo.id" :class="subtitulo.tipo == 'prime' ? 'no_aplica_li':''" >{{subtitulo.nombre}}</li>
                        </ul>
                    </li>
                </ul>

                </b-collapse>
                <b-link href="#" v-b-toggle.plan_detail class="link_plan">
                    <span class="when-opened">
                    Ver menos detalles
                    </span>
                    <span class="when-closed">
                    Ver más detalles
                    </span>
                </b-link>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12 caja_prime">
            <div class=" col-lg-6 col-sm-12 ">
                <h1 class="plan_titulo prime_text"> PREMIUM </h1>
                <h2 class="plan_subtitulo prime_text">Sistema completo</h2>
                <br />
                <img class="img_opciones mb-4" src="static/images/planes.png" alt="plan_pro" />
                <br />

                <ul  class="lista_plan prime_text">
                    <li v-for="plan in planes" :key="plan.id" :class="plan.tipo == 'basic' ? 'no_aplica':''" >{{plan.nombre}}</li>
                </ul>

            </div>
            <div class="prime_content" style="text-align: center; padding-top:30%; padding-bottom:10%">
                <b-button @click="linkContact()" pill class="btn btn_plan prime_btn">Solicitar demo</b-button>
                <br />
                <b-collapse id="plan_detail_pro">

                <ul  class="lista_plan_completo prime_lpc">
                    <li v-for="plan in planes" :key="plan.id" :class="plan.tipo == 'basic' ? 'no_aplica_completo':''" >
                        {{plan.nombre}}
                        <ul>
                            <li v-for="subtitulo in plan.subtitulos" :key="subtitulo.id" :class="subtitulo.tipo == 'basic' ? 'no_aplica_li':''" >{{subtitulo.nombre}}</li>
                        </ul>
                    </li>
                </ul>

                </b-collapse>
                <b-link href="#" v-b-toggle.plan_detail_pro class="link_plan prime_link">
                    <span class="when-opened">
                    Ver menos detalles
                    </span>
                    <span class="when-closed">
                    Ver más detalles
                    </span>
                </b-link>
            </div>
            </div>
        </div>
        </div>
    </div>
    <div class="col-lg-12 " id="plan" v-else>
        <div class="container bg-organiza">
        <h1 class="titulo_planes"> Haz click con tu capital humano</h1>
        <div class="row">
            <div data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="100" class="col-lg-6 col-sm-12 pb-5">
            <div class="col-lg-8 col-sm-12 caja_planes float-right">
                <h1 class="plan_titulo"> BASIC </h1>
                <h2 class="plan_subtitulo">Sistema básico</h2>
                <br />
                <img class="img_opciones" src="static/images/planes.png" alt="plan_basico" />
                <br />

                <ul  class="lista_plan">
                    <li v-for="plan in planes" :key="plan.id" :class="plan.tipo == 'prime' ? 'no_aplica':''" >{{plan.nombre}}</li>
                </ul>
                
                <div style="text-align: center; padding-top:10%; padding-bottom:10%">
                <b-button @click="linkContact()" pill class="btn btn_plan">Solicitar demo</b-button>
                <br/>
                <b-collapse id="plan_detail">

                <ul  class="lista_plan_completo">
                    <li v-for="plan in planes" :key="plan.id" :class="plan.tipo == 'prime' ? 'no_aplica_completo':''" >
                        {{plan.nombre}}
                        <ul>
                            <li v-for="subtitulo in plan.subtitulos" :key="subtitulo.id" :class="subtitulo.tipo == 'prime' ? 'no_aplica_li':''" >{{subtitulo.nombre}}</li>
                        </ul>
                    </li>
                </ul>

                </b-collapse>
                <b-link href="#" v-b-toggle.plan_detail class="link_plan">
                    <span class="when-opened">
                    Ver menos detalles
                    </span>
                    <span class="when-closed">
                    Ver más detalles
                    </span>
                </b-link>
                </div>
            </div>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="300" class="col-lg-6 col-sm-12">
            <div class=" col-lg-8 col-sm-12 caja_planes caja_prime">
                <h1 class="plan_titulo prime_text"> PREMIUM </h1>
                <h2 class="plan_subtitulo prime_text">Sistema completo</h2>
                <br />
                <img class="img_opciones" src="static/images/planes.png" alt="plan_pro" />
                <br />
                
                <ul  class="lista_plan prime_text">
                    <li v-for="plan in planes" :key="plan.id" :class="plan.tipo == 'basic' ? 'no_aplica':''" >{{plan.nombre}}</li>
                </ul>

                <div style="text-align: center; padding-top:10%; padding-bottom:10%">
                <b-button @click="linkContact()" pill class="btn btn_plan prime_btn">Solicitar demo</b-button>
                <br />
                <b-collapse id="plan_detail">

                <ul  class="lista_plan_completo prime_lpc">
                    <li v-for="plan in planes" :key="plan.id" :class="plan.tipo == 'basic' ? 'no_aplica_completo':''" >
                        {{plan.nombre}}
                        <ul>
                            <li v-for="subtitulo in plan.subtitulos" :key="subtitulo.id" :class="subtitulo.tipo == 'basic' ? 'no_aplica_li':''" >{{subtitulo.nombre}}</li>
                        </ul>
                    </li>
                </ul>

                </b-collapse>
                <b-link href="#" v-b-toggle.plan_detail class="link_plan prime_link">
                    <span class="when-opened">
                    Ver menos detalles
                    </span>
                    <span class="when-closed">
                    Ver más detalles
                    </span>
                </b-link>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>

import planesApi from "../api/planes";

export default {
    data() {
        return {
            planes:[]
        }
    },
    methods: {
        getPlanes(){
            let params = {activo:true,order:"asc",order_by:"orden",paginate:false}
            planesApi
            .getPlanes(params)
            .then(response => {
                this.planes = response.data;
            }).catch(err => {
                console.log("Ocurrio un error al cargar los planes.");
            });
        },
        isMobile: function() {
            var check = false;
            //console.log(window.screen.width);
            if(window.screen.width < 769){
                return check=true;
            }
        },
        linkContact(){
            setTimeout(function(){
                window.location = "#contacto"; 
            },100);
        },
    },
    created() {
        this.getPlanes();
    }
  }
</script>

<style scoped>
  #intro{
    height: 80vh;
    padding-top: 3%;
    padding-bottom: auto;
  }

  #beneficios{
    padding-top:60px;
  }

  #opciones{
    padding-bottom:60px;
  }

  #facial{
    padding-top:100px;
    padding-bottom:80px;
  }

  #plan{
    padding-top:20px;
    margin-bottom:-160px;
  }

  #precio{
    padding-top:40px;
  }

  .titulo_intro {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 45px;
    line-height: 55px;
    letter-spacing: 0.2px;

    color: #1E2245;
    text-align: left;
    padding-bottom: 20px;
    padding-top:7%;
  }

  
  
  .img_intro img {
    width: 50%;
  }

   .img_intro_app {
    position:absolute;
    margin-left:38%;
    margin-top:-100px;
    z-index: -1;
  }
  
  .img_intro_app img {
    width: 100%;
  }

  .text_intro{
    font-family: Muli-bold;
    font-style: normal;
    font-size: 30px;
    line-height: 40px;

    text-align: left;
    letter-spacing: 0.2px;
    color: #4F4F4F;
  }

  .btn_intro {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    margin-top: 59px;
    padding: 13px 27px;
  }

  .btn_intro:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .btn_video {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #FFFFFF;
    border-color: #FFFFFF;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
    border-radius: 100px;
    padding: 13px 27px;
    color: #1E2245;
    margin-top:61vh;
    margin-left: auto;
  }

  .btn_video:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }


  /* boton subir
  */
  #myBtn {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: red;
    color: white;
    cursor: pointer;
    padding: 15px;
    border-radius: 4px;
  }

  #myBtn:hover {
    background-color: #555;
  }

  /**
  * DIVIDERS
  */
  .divider-01 {
    height: 5px;
    width: 8%;
    background-color: #E8404E;
    border-radius: 3px;
    margin: 35px;
    margin-left: auto;
    margin-right: auto;
  }

  .divider-02 {
  height: 5px;
    width: 8%;
    background-color: #8EE8E1;
    border-radius: 3px;
    margin: 35px;
    margin-left: auto;
    margin-right: auto;
  }


  /**Estilo beneficios seccion */
  

  .beneficios {
    padding-top: 100px;
    padding-bottom: 300px;
    background-color: #738AF850;
  }

  .bg-beneficios {
    background: url("/static/images/bg_azul.svg") repeat-x;
  }

  .titulo_beneficio {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 45px;
    line-height: 80px;

    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2245;
    
  }

  .imagen_beneficios {
    padding-top: 100px;
    padding-bottom: 50px;
  }

  .imagen_beneficios img {
    width: 80%;
  }

  .titulo_opciones {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 22px;
    line-height: 22px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;

    color: #1E2245;
    padding-bottom: 40px;
  }

  .texto_opciones {
    font-family: Muli-Semibold;
    font-style: normal;
    font-size: 14px;
    line-height: 22px;
    text-align: left;

    letter-spacing: 0.2px;
    color: #4F4F4F;
    padding: 0px 40px;
  }

  .img_opciones {
    width: 60%;
    padding-bottom: 40px;
  }

  .caja_planes .img_opciones {
    padding-bottom: 17%;
  }

  .titulo_facial {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 45px;
    line-height: 80px;

    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2245;
    padding-bottom:50px;
  }

  .text_facial {
    padding-top: 40px;

  }

  .planes {
    padding-left: 5%;
    padding-right: 5%;
    padding-top: 40px;
    padding-bottom: 50px;
  }

  .titulo_planes {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 38px;
    line-height: 18px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2144;
    margin-top: 40px;
    margin-bottom: 120px;
  }

  .caja_planes{
    background: #FFFFFF;
    box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
    border-radius: 25px;
    margin-bottom:150px;
    padding-top:30px;
  }

  .caja_prime{
    background:#1E2245;
  }

  .plan_titulo {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-size: 26px;
    line-height: 18px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #2DB9D1;

    padding-top: 24px;
  }

  .prime_text{
    color: #FFFFFF !important;
  }

  .plan_subtitulo {
    font-family: Muli-Semibold;
    font-style: normal;
    font-size: 18px;
    line-height: 18px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2144;
  }

  .btn_plan {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    background: #1E2144;
    border-radius: 18px;
    letter-spacing: 0.3px;
    border-color: #1E2144 !important;
    color: #FFFFFF;
    padding: 13px 27px;
  }

  .prime_btn {
    background: #2DB9D1;
  }

  .link_plan {
    font-family: Muli-Semibold;
    font-style: normal;
    font-size: 14px;
    line-height: 22px;
    align-items: center;
    letter-spacing: 0.2px;
    color:#1E2245;

    margin-top: 25px;
    display: block;
  }

  .prime_link{
    color:#FFFFFF;
  }

  .mid_text > p{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0.2px;
    color: #4F4F4F;
  }

  .lista_plan {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }

  .lista_plan > li {
    background: url('/static/images/icons/flecha.png') no-repeat left center;
    font-family: Muli-Semibold;
    font-style: normal;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;

    padding-left: 25px;
    margin-bottom: 3%;
    color: #1E2144;
  }

  .prime_text > li{
    background: url('/static/images/icons/flecha_white.png') no-repeat left center;
    color:#FFFFFF;
  }

  .lista_plan > li > span {
    color: #2DB9D1;
  }

  .no_aplica {
    background: url('/static/images/icons/tache.png') no-repeat left center !important;
    padding-left: 25px;
    color: #BDBDBD !important;
  }

   .lista_plan_completo {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
    margin-top:100px;
    margin-bottom:100px;
  }

  .lista_plan_completo > li {
    font-family: Muli;
    font-style: normal;
    font-size: 14px;
    font-weight: bold;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    margin-bottom: 20px;
    color: #1E2144;
  }

  .prime_lpc > li{
    color:#FFFFFF;
  }

  .prime_lpc > li > ul > li{
    color:#FFFFFF !important;
    background: url('/static/images/icons/flecha_white.png') no-repeat left 5px !important;
  }


  .lista_plan_completo > li > ul {
   padding-left:0px;
   margin-top:15px;
  }

  .lista_plan_completo > li > ul > li {
    background: url('/static/images/icons/paloma_gris.png') no-repeat left 5px;
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    padding-left: 25px;
    color: #828282;
    margin-bottom:5px;
  }

  .no_aplica_completo {
    color: #BDBDBD !important;
  }

  .no_aplica_completo > ul > li {
    background: url('/static/images/icons/tache.png') no-repeat left center !important;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    padding-left: 25px;
    color: #BDBDBD !important;
  }

  .no_aplica_li{
    background: url('/static/images/icons/tache.png') no-repeat left center !important;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    padding-left: 25px;
    color: #BDBDBD !important;
  }

  /**Estilos de chat */
  .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    width: 340px;
    height: 572px;
    left: 149px;
    background: #FFFFFF;
    box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.1);
    border-radius: 10px;
  }

  .card-title {
    height: 5.0625rem;
    background: #3C64B1;
    border-radius: 10px 10px 0px 0px;
    padding-top: 1em;
    color: #FFF;
  }
  .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }

  @media(min-width: 1500px){
     #intro{
      height: 85vh;
      padding-top: 5%;
      padding-bottom: auto;
    }

    .img_intro_app{
      padding-top:100px;
    }
    .titulo_intro{
      padding-top:130px;
    }
    .btn_video{
      margin-top:58vh;
    }
   
  }

  @media(max-width: 768px){
    #intro{
      margin-top:0px;
      padding-top:0px;
      height: 100%;
    }

    #beneficios{
      padding-top:0px;
    }

    #opciones{
      padding-bottom:0px;
    }

    #facial{
      padding-top:0px;
      padding-bottom:0px;
    }

    #plan{
      padding-top:0px;
      margin-right: 0px;
      margin-left: 0px;
      margin-bottom:0px;
    }
    .prime_content{
      padding:15px;
    }

    .caja_prime{
      background: #1E2245;
    }

    .mid_text > p{
      margin-bottom:80px;
    }

    #precio{
      padding-top:0px;
    }

    .titulo_intro {
      font-size: 32px;
      line-height: 40px;
    }

    .text_intro{
      font-size: 14px;
      line-height: 25px;
    }

    .btn_intro {
      width: 100%; 
      margin-bottom: 25px;
      padding-bottom: 13px;
      padding-top:13px;
      border-radius: 14px;
    }

    .titulo_beneficio {
      padding-top: 20px;
      font-size: 26px;
      line-height:0px;
      color: #1E2245;
      
    }
    
    .bg-beneficios {
      background: url("/static/images/bg_azul.svg") repeat-x;
      background-size: 414px;
    }

    .imagen_beneficios {
      padding-top: 50px;
    }

    .imagen_beneficios img{
      width: 100%;
    }

    .titulo_opciones {
      font-size: 16px;
      line-height: 0px;
      letter-spacing: 0.06px;
      align-items: left;
      text-align: left;
      color: #1E2245;
      padding-bottom: 0px;
      padding-top: 10px;
    }

    .texto_opciones {
      font-size: 12px;
      line-height: 14px;
      text-align: left;
      padding:0px;
      padding-top: 10px;
      letter-spacing: 0.06px;
      width: 90%;
      color: #4F4F4F;
    }

    .img_opciones {
        width: 60%;
        padding-top: 20px;
        padding-bottom: 0px;
        margin-bottom: -45px;
      }

    .chevron{
      color:#2DB9D1;
      font-size: 16px;
      }  

    .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }

    .titulo_facial {
       padding-top: 20px;
      font-size: 26px;
      line-height:0px;
      color: #1E2245;
      }

    .text_facial {
      padding-top: 40px;
      text-align: center;
      font-style: normal;
      font-weight: 600;
      line-height: 14px;
      letter-spacing: 0.06px;
      font-size: 12px;
      padding-bottom:0px;
      }

      .custom-hr1{

      }

      .custom-hr2{
        margin-left: -2%;
        margin-right: -2%;
        border: 0.5px solid #3C64B1;
      }

      .titulo_planes {
        font-size: 26px;
        line-height: 32px;
        letter-spacing: 0.2px;
        color: #1E2144;
        margin-top: -50px;
        margin-bottom: 30px;
      }

      .btn_plan {
        width: 100%; 
      padding-bottom: 13px;
      padding-top:13px;
      border-radius: 14px;
      }

      
      .lista_plan {
        padding-top: 50px;
        text-align: left;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        height: 160px;
      }

      .lista_plan > li {
        background: url('/static/images/icons/flecha.png') no-repeat left center;
        height: 20px;
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0.2px;
        text-align: left;
        list-style:none;

        padding-left: 25px;
        margin-bottom: 5%;
        color: #1E2144;
      }

      .prime_text > li{
    background: url('/static/images/icons/flecha_white.png') no-repeat left center;
    color:#FFFFFF;
  }

      .lista_plan_completo {
        text-align: left;
        margin-left: auto;
        margin-right: auto;
        padding:auto;
        width: 100%;
        margin-top:100px;
      }

      .lista_plan_completo > li {
        font-family: Muli;
        font-style: normal;
        font-size: 14px;
        font-weight: bold;
        line-height: 22px;
        letter-spacing: 0.2px;
        text-align: left;
        list-style:none;
        margin-bottom: 20px;
        color: #1E2144;
      }

      .prime_lpc > li{
        color:#FFFFFF;
      }
      .prime_lpc > li > ul > li{
        color:#FFFFFF !important;
        background: url('/static/images/icons/flecha_white.png') no-repeat left 5px !important;
      }

  .lista_plan_completo > li > ul {
   padding-left:0px;
   margin-top:15px;
  }

  .lista_plan_completo > li > ul > li {
    background: url('/static/images/icons/paloma_gris.png') no-repeat left 5px;
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.2px;
    text-align: left;
    list-style:none;
    padding-left: 25px;
    color: #828282;
    margin-bottom:5px;
  }


      .divider-02 {
        height: 5px;
        width: 120px;
        background-color: #8EE8E1;
        border-radius: 3px;
        margin-top: -10px;
        margin-left: auto;
        margin-right: auto;
      }

  }

  @media only screen and(max-width: 30%) {
    #demo {
      display: none;
    }
  }
</style>